import React, { Fragment, useEffect, useState } from "react";
import {
  obtenerNotificacion,
  actualizarNotificacion,
} from "../../actions/Notificaciones";

import {
  Badge,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Menu,
} from "@material-ui/core";

import NotificationsRoundedIcon from "@material-ui/icons/NotificationsRounded";
import { useStyles } from "../../assets/js/HeaderStyle";

export default function Notification() {
  const [notificaciones, setNotificaciones] = useState([]);
  const [actualizaciones, setActualizaciones] = useState([]);
  const dropDownDataurl =
    "https://mocki.io/v1/c974967e-88a2-4755-934f-7b54d9d14f3d";
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [statenoti, setNotification] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState([]);

  const dejarVisto = (event, id) => {
    setNotification(!statenoti);

    setAnchorEl(null);
    var myindex = { id };
    if(!myindex){
      //console.log("aquiiii");
      return null;
    } else {
    actualizarNotificacion(myindex)
      .then((response) => {
        //console.log(response);

        setData(response);
        peticionGet();
      })
      .catch((error) => {
        //console.log(error);
      });
    }
    setSelectedIndex(id);
  };
  const handleClick = (event) => {
    event.preventDefault();
    //console.log(event.target.value);
    setAnchorEl(event.currentTarget);
    //console.log("handleClicked ", event.currentTarget);
  };

  const handleClose = () => {
    setNotification(!statenoti);

    setAnchorEl(null);

  };

  const peticionGet = async () => {
    const datosUsuario = JSON.parse(window.sessionStorage.getItem("usuario"));
    const idColaborador = datosUsuario.result.colaborador.id;
    
    if(!idColaborador){
      return null;
    } else {
    obtenerNotificacion(idColaborador)
      .then((response) => {
        //console.log(response.data.result);

        let data = response.data.result
        let dataFormateada = [];

        data.forEach(element => {
          let cadena = element.fecha.split('T');
          var fechaFormateada = cadena[0].split('-').reverse().join('-');
          element.fecha = fechaFormateada;
          dataFormateada.push(element);
        });

        setNotificaciones(dataFormateada);
      })
      .catch((error) => {
        //console.log(error);
        
      });
    }
  };

  const notificacionesone = Object.entries(notificaciones);
  //console.log(notificacionesone);

  useEffect(() => {
    const timer = setTimeout(() => {
      peticionGet();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const timerInter = setInterval(() => {
      peticionGet();
    }, 90000);
    return () => clearTimeout(timerInter);
  }, []);
  return (
    <Fragment>
      <IconButton
        aria-controls="notification"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Badge
          overlap="rectangular"
          badgeContent={notificaciones.length}
          color="secondary"
        >
          <NotificationsRoundedIcon />
        </Badge>
      </IconButton>
      <Menu
        id="notification"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        placement="bottom-start"
      >
        <List dense={true} className={classes.dropdownlist}>
          {notificacionesone.map(([i, value]) => {
            // {dropDownData.map((item, i) => (
            //console.log(value.mensaje);
            //console.log(value.id);
            return (
              <ListItem
                key={value.id} 
                component={Button}
                onClick={(event) => dejarVisto(event, value.id)}
                className={classes.listItem}
              >
                <ListItemText
                  primary={value.fecha}
                  secondary={value.mensaje}
                ></ListItemText>
              </ListItem>
            );
          })}
        </List>
      </Menu>
    </Fragment>
  );
}
